import checkapplys from '@/view/check-apply-scoring';

const checks = {
    install:function (Vue) {
        Vue.component('checks',checkapplys)
    }
}
export default checks;